<section class="customer-form">
  <div class="customer-form__save-bar">
    <div class="customer-form__save-bar-inner">
      <div class="customer-form__save-bar-left">
        <button
          type="button"
          class="customer-form__back-btn"
          (click)="onCancel()"
          [attr.aria-label]="'clientManagement.customerForm.back' | translate"
        >
          <mat-icon aria-hidden="true">chevron_left</mat-icon>
        </button>
        <div class="customer-form__save-bar-title">
          <span class="customer-form__eyebrow">
            {{
              isEdit
                ? ('clientManagement.customerForm.editTitle' | translate)
                : ('clientManagement.customerForm.createTitle' | translate)
            }}
          </span>
          <h1>
            {{
              isEdit
                ? form.value.name || ('clientManagement.customerForm.editTitle' | translate)
                : ('clientManagement.customerForm.create' | translate)
            }}
          </h1>
        </div>
        @if (isDirty()) {
          <span class="customer-form__dirty-pill">
            <span class="customer-form__dirty-dot"></span>
            {{ 'clientManagement.customerForm.unsavedChanges' | translate }}
          </span>
        }
      </div>
      <div class="customer-form__save-bar-actions">
        <button type="button" class="customer-form__secondary-btn" (click)="onCancel()">
          {{ 'clientManagement.customerForm.cancel' | translate }}
        </button>
        <button type="button" class="customer-form__primary-btn" [disabled]="saveDisabled()" (click)="onSave()">
          <mat-icon aria-hidden="true">check</mat-icon>
          {{
            isEdit
              ? ('clientManagement.customerForm.save' | translate)
              : ('clientManagement.customerForm.create' | translate)
          }}
        </button>
      </div>
    </div>
  </div>

  @if (loading()) {
    <div class="customer-form__loading">
      <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    </div>
  } @else if (loadError()) {
    <p class="customer-form__error">{{ loadError()! | translate }}</p>
  } @else {
    <div class="customer-form__content">
      <div class="customer-form__main">
        <form [formGroup]="form">
          <section class="customer-form__card" [attr.aria-labelledby]="grunddatenHeadingId">
            <to-section-title
              [headingId]="grunddatenHeadingId"
              [title]="'clientManagement.customerForm.grunddaten' | translate"
              [subtitle]="'clientManagement.customerForm.grunddatenTitle' | translate"
            />

            <div class="customer-form__fields">
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="customer-form__field tc-field tc-field--uppercase-label"
              >
                <mat-label>{{ 'clientManagement.customerForm.name' | translate }}</mat-label>
                <input
                  matInput
                  formControlName="name"
                  placeholder="z. B. Spirit-Testing GmbH"
                  [attr.maxlength]="fieldLengths.NAME_MAX"
                  aria-required="true"
                />
                @if (form.controls.name.touched && form.controls.name.hasError('required')) {
                  <mat-error>{{ 'clientManagement.customerForm.nameRequired' | translate }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="customer-form__field tc-field tc-field--uppercase-label"
              >
                <mat-label>{{ 'clientManagement.customerForm.domain' | translate }}</mat-label>
                <input
                  matInput
                  formControlName="domain"
                  placeholder="kunde.com"
                  [attr.maxlength]="fieldLengths.NAME_MAX"
                />
              </mat-form-field>

              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="customer-form__field tc-field tc-field--uppercase-label"
              >
                <mat-label>{{ 'clientManagement.customerForm.contactPerson' | translate }}</mat-label>
                <input
                  matInput
                  formControlName="contactPerson"
                  [attr.maxlength]="fieldLengths.NAME_MAX"
                  aria-required="true"
                />
                @if (form.controls.contactPerson.touched && form.controls.contactPerson.hasError('required')) {
                  <mat-error>{{ 'clientManagement.customerForm.contactPersonRequired' | translate }}</mat-error>
                }
              </mat-form-field>
            </div>
          </section>

          <section class="customer-form__card" [attr.aria-labelledby]="hostingHeadingId">
            <to-section-title
              [headingId]="hostingHeadingId"
              [title]="'clientManagement.customerForm.hostingZugang' | translate"
              [subtitle]="'clientManagement.customerForm.hostingZugangSubtitle' | translate"
            />

            <div class="customer-form__fields">
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="customer-form__field tc-field tc-field--uppercase-label"
              >
                <mat-label>{{ 'clientManagement.customerForm.hostingMode' | translate }}</mat-label>
                <mat-select formControlName="hostingMode" aria-required="true">
                  <mat-option value="MANAGED">{{ 'clientManagement.hostingMode.MANAGED' | translate }}</mat-option>
                  <mat-option value="SELF_HOSTED">
                    {{ 'clientManagement.hostingMode.SELF_HOSTED' | translate }}
                  </mat-option>
                </mat-select>
                @if (form.controls.hostingMode.touched && form.controls.hostingMode.hasError('required')) {
                  <mat-error>{{ 'clientManagement.customerForm.hostingModeRequired' | translate }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="customer-form__field tc-field tc-field--uppercase-label"
              >
                <mat-label>{{ 'clientManagement.customerForm.azureTenantId' | translate }}</mat-label>
                <input
                  matInput
                  formControlName="azureTenantId"
                  placeholder="xxxxxxxx-xxxx-…"
                  [attr.maxlength]="fieldLengths.NAME_MAX"
                  aria-required="true"
                />
                @if (form.controls.azureTenantId.touched && form.controls.azureTenantId.hasError('required')) {
                  <mat-error>{{ 'clientManagement.customerForm.azureTenantIdRequired' | translate }}</mat-error>
                }
              </mat-form-field>
            </div>
          </section>

          <section class="customer-form__card" [attr.aria-labelledby]="authHeadingId">
            <to-section-title
              [headingId]="authHeadingId"
              [title]="'clientManagement.customerForm.authAccess.title' | translate"
              [subtitle]="'clientManagement.customerForm.authAccess.subtitle' | translate"
            />

            <div class="customer-form__auth-block">
              <div class="customer-form__auth-label-row">
                <span class="customer-form__auth-label" [id]="authMethodLabelId">
                  {{ 'clientManagement.customerForm.authAccess.methodLabel' | translate }}
                </span>
                <code class="customer-form__code-chip">auth_method</code>
              </div>
              <div
                class="customer-form__auth-options"
                role="radiogroup"
                [attr.aria-labelledby]="authMethodLabelId"
                [attr.aria-describedby]="domainsErrorRef()"
              >
                @for (method of authMethods; track method) {
                  @let checked = form.controls.authMethod.value === method;
                  <button
                    type="button"
                    role="radio"
                    class="customer-form__auth-option"
                    [class.customer-form__auth-option--checked]="checked"
                    [attr.aria-checked]="checked"
                    [attr.tabindex]="checked ? 0 : -1"
                    [attr.data-testid]="'customer-auth-method-' + method"
                    (click)="selectAuthMethod(method)"
                    (keydown)="onAuthMethodKeydown($event, method)"
                  >
                    <span class="customer-form__auth-radio" aria-hidden="true"></span>
                    <span class="customer-form__auth-text">
                      <span class="customer-form__auth-head">
                        <code class="customer-form__auth-code">{{ method }}</code>
                        <span class="customer-form__auth-title">
                          {{ 'clientManagement.customerForm.authAccess.methods.' + method + '.title' | translate }}
                        </span>
                        @if (checked) {
                          <span class="customer-form__auth-badge">
                            {{ 'clientManagement.customerForm.authAccess.active' | translate }}
                          </span>
                        }
                      </span>
                      <span class="customer-form__auth-desc">
                        {{ 'clientManagement.customerForm.authAccess.methods.' + method + '.desc' | translate }}
                      </span>
                    </span>
                  </button>
                }
              </div>
            </div>

            <div class="customer-form__auth-block">
              <span class="customer-form__auth-label customer-form__auth-label--block">
                {{ 'clientManagement.customerForm.authAccess.domainsLabel' | translate }}
              </span>
              <p class="customer-form__auth-hint">
                {{ 'clientManagement.customerForm.authAccess.domainsHint' | translate }}
              </p>
              <div class="customer-form__domains">
                @for (control of form.controls.allowedDomains.controls; track control; let i = $index) {
                  <div class="customer-form__domain-row">
                    <span class="customer-form__domain-at" aria-hidden="true">&#64;</span>
                    <mat-form-field
                      appearance="outline"
                      subscriptSizing="dynamic"
                      class="customer-form__domain-field tc-field"
                    >
                      <input
                        matInput
                        [formControl]="control"
                        [errorStateMatcher]="domainErrorMatcher"
                        [aria-describedby]="domainsErrorRef() ?? ''"
                        placeholder="kunde.com"
                        [attr.aria-label]="
                          'clientManagement.customerForm.authAccess.domainAria' | translate: { index: i + 1 }
                        "
                        [attr.data-testid]="'customer-allowed-domain-' + i"
                      />
                      @if (control.hasError('domainTaken')) {
                        <mat-error>
                          {{
                            'clientManagement.customerForm.authAccess.domainTaken'
                              | translate: control.getError('domainTaken')
                          }}
                        </mat-error>
                      }
                      @if (control.hasError('invalidDomain')) {
                        <mat-error>
                          {{ 'clientManagement.customerForm.authAccess.invalidDomain' | translate }}
                        </mat-error>
                      }
                    </mat-form-field>
                    <button
                      type="button"
                      class="customer-form__domain-remove"
                      [attr.aria-label]="
                        'clientManagement.customerForm.authAccess.removeDomainAria' | translate: { index: i + 1 }
                      "
                      [title]="'clientManagement.customerForm.authAccess.removeDomain' | translate"
                      [attr.data-testid]="'customer-allowed-domain-remove-' + i"
                      (click)="removeDomain(i)"
                    >
                      <mat-icon aria-hidden="true">delete_outline</mat-icon>
                    </button>
                  </div>
                }
                <button
                  type="button"
                  class="customer-form__domain-add"
                  data-testid="customer-allowed-domain-add"
                  (click)="addDomain()"
                >
                  <mat-icon aria-hidden="true">add</mat-icon>
                  {{ 'clientManagement.customerForm.authAccess.addDomain' | translate }}
                </button>
              </div>
              @if (form.hasError('otpRequiresDomain')) {
                <p class="customer-form__domains-error" role="alert" [id]="domainsErrorId">
                  {{ 'clientManagement.customerForm.authAccess.otpRequiresDomain' | translate }}
                </p>
              }
            </div>

            <div class="customer-form__auth-note">
              <mat-icon aria-hidden="true">shield</mat-icon>
              <span [innerHTML]="'clientManagement.customerForm.authAccess.invitationHint' | translate"></span>
            </div>
          </section>

          <section class="customer-form__card" [attr.aria-labelledby]="vertragHeadingId">
            <to-section-title
              [headingId]="vertragHeadingId"
              [title]="'clientManagement.customerForm.vertrag' | translate"
              [subtitle]="'clientManagement.customerForm.vertragSubtitle' | translate"
            />

            <div class="customer-form__contract-grid">
              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="customer-form__field tc-field tc-field--uppercase-label"
              >
                <mat-label>{{ 'clientManagement.customerForm.contractStart' | translate }}</mat-label>
                <input matInput [matDatepicker]="startPicker" formControlName="contractStart" />
                <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
                @if (form.controls.contractStart.hasError('matDatepickerParse')) {
                  <mat-error>{{ 'common.errors.invalidDate' | translate }}</mat-error>
                }
              </mat-form-field>

              <mat-form-field
                appearance="outline"
                floatLabel="always"
                class="customer-form__field tc-field tc-field--uppercase-label"
              >
                <mat-label>{{ 'clientManagement.customerForm.contractEnd' | translate }}</mat-label>
                <input matInput [matDatepicker]="endPicker" formControlName="contractEnd" />
                <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
                @if (form.controls.contractEnd.hasError('matDatepickerParse')) {
                  <mat-error>{{ 'common.errors.invalidDate' | translate }}</mat-error>
                }
              </mat-form-field>
            </div>
          </section>

          @if (saveError()) {
            <p class="customer-form__error">{{ saveError()! | translate }}</p>
          }
        </form>
      </div>

      <aside class="customer-form__sidebar">
        <div class="customer-form__card customer-form__card--sidebar">
          <p class="customer-form__sidebar-label">
            {{ 'clientManagement.customerForm.eigenschaften' | translate }}
          </p>
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            class="customer-form__field tc-field tc-field--uppercase-label"
          >
            <mat-label>{{ 'clientManagement.customerForm.status' | translate }}</mat-label>
            <mat-select [formControl]="form.controls.status" aria-required="true">
              <mat-option value="ACTIVE">{{ 'clientManagement.status.ACTIVE' | translate }}</mat-option>
              <mat-option value="INACTIVE">{{ 'clientManagement.status.INACTIVE' | translate }}</mat-option>
              <mat-option value="ONBOARDING">{{ 'clientManagement.status.ONBOARDING' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="customer-form__card customer-form__card--sidebar">
          <p class="customer-form__sidebar-label">{{ 'clientManagement.customerForm.preview' | translate }}</p>
          <div class="customer-form__preview-identity">
            <div class="customer-form__preview-avatar">{{ initials || '??' }}</div>
            <div>
              <p class="customer-form__preview-name">{{ form.value.name || 'Kundenname' }}</p>
              <p class="customer-form__preview-domain">{{ form.value.domain || 'domain.com' }}</p>
            </div>
          </div>
          <div class="customer-form__meta-rows">
            @if (form.value.status) {
              <div class="customer-form__meta-row">
                <span class="customer-form__meta-label">{{ 'clientManagement.customerForm.status' | translate }}</span>
                <app-status-pill [kind]="statusKind(form.value.status)" />
              </div>
            }
            <div class="customer-form__meta-row">
              <span class="customer-form__meta-label">{{ 'clientManagement.customerForm.hosting' | translate }}</span>
              @if (form.value.hostingMode) {
                <span class="customer-form__hosting-pill">
                  <span class="customer-form__hosting-dot"></span>
                  {{ 'clientManagement.hostingMode.' + form.value.hostingMode | translate }}
                </span>
              } @else {
                <span class="customer-form__meta-value">—</span>
              }
            </div>
            <div class="customer-form__meta-row">
              <span class="customer-form__meta-label">
                {{ 'clientManagement.customerForm.contractEnd' | translate }}
              </span>
              <span class="customer-form__meta-value">
                @if (form.value.contractEnd) {
                  {{ form.value.contractEnd | date: 'dd.MM.yyyy' }}
                } @else {
                  —
                }
              </span>
            </div>
          </div>
        </div>
      </aside>
    </div>
  }
</section>

<lib-modal
  [title]="'clientManagement.customerForm.deactivateConfirm.title' | translate"
  [text]="'clientManagement.customerForm.deactivateConfirm.message' | translate"
  [visible]="showDeactivateConfirm()"
  [saveText]="'clientManagement.customerForm.deactivateConfirm.confirm' | translate"
  [cancelText]="'clientManagement.customerForm.deactivateConfirm.cancel' | translate"
  (save)="onDeactivateConfirmed()"
  (cancel)="onDeactivateCancelled()"
  (visibleChange)="!$event && onDeactivateCancelled()"
></lib-modal>

<lib-modal
  [title]="'clientManagement.customerForm.authAccess.confirm.title' | translate"
  [text]="authChangeWarning() ?? ''"
  [visible]="!!authChangeWarning()"
  [saveText]="'clientManagement.customerForm.authAccess.confirm.confirm' | translate"
  [cancelText]="'clientManagement.customerForm.authAccess.confirm.cancel' | translate"
  (save)="onAuthChangeConfirmed()"
  (cancel)="onAuthChangeCancelled()"
  (visibleChange)="!$event && onAuthChangeCancelled()"
></lib-modal>
